$(document).ready(function(){
  $("a.logo-bar__link[href='https://www.alrossa.com/collections/vendors?q=Senteurs%20d%27Orient'] img").attr("alt", "Senteurs d'Orient logo");
$("a.logo-bar__link[href='https://www.alrossa.com/collections/vendors?q=L%27Atelier%20du%20Vin'] img").attr("alt", "L'Atelier du Vin logo");
$("a.logo-bar__link[href='https://www.alrossa.com/collections/vendors?q=Dr.%20Nigma'] img").attr("alt", "Dr. Nigma logo");
$("a.logo-bar__link[href='https://www.alrossa.com/collections/vendors?q=Arte%20Italica'] img").attr("alt", "Arte Italica logo");
$("a.logo-bar__link[href='https://www.alrossa.com/collections/vendors?q=Branch%C3%A9'] img").attr("alt", "Branché logo");
$("a.logo-bar__link[href='/collections/nude'] img").attr("alt", "Nude logo");
$("a.hero__slide-link[href='https://alrossa.com/collections/sunkissed']").attr("aria-label", "Shop Sunkissed Collection");
$("a.hero__slide-link[href='https://www.alrossa.com/search?q=rosy+rings&type=product']").attr("aria-label", "Search results for Rosy Rings products");
$("img[src='https://static.shopify.com/s/files/1/0181/7277/files/Vali_signature-small.jpeg?215']").attr("alt", "Vali logo");

$("a.hero__slide-link[href='https://www.alrossa.com/search?type=product&q=*Momotaro%20Apotheca*']").attr("aria-label", "Search results for Momotaro Apotheca products");
$("a[href='https://alrossa.com/collections/vendors?q=Saya']").attr("aria-label", "View all products from vendor Saya");
$("input.price-range__input-min").attr("aria-label", "Minimum price");
$("input.price-range__input-max").attr("aria-label", "Maximum price");
$("img[src='//alrossa.com/cdn/shop/files/unnamed_100x.png?v=1642449804']").attr("alt", "Alrossa logo");
$("textarea#h-captcha-response-0h6lmhh525r").attr("aria-label","Enter Captcha");
 $("div.type-banner__text p:nth-child(3).btn.btn--secondary.btn--small").each(function() {
    var link = $(this);
    var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
    link.html(spanElement);
});

 $("a.btn.return-link[href^='/collections/']").each(function() {
  var link = $(this);
  
  // Extract and store the existing SVG (if any)
  var svg = link.find('svg').clone();

  // Get the link text (excluding the SVG)
  var linkText = link.clone().children().remove().end().text().trim();

  // Create a <span> with the text and class
  var spanElement = $('<span>').text(linkText).addClass('bc');

  // Clear the link and append the SVG followed by the span
  link.empty().append(svg).append(' ').append(spanElement);
});
$("select.product-single__variants").attr("aria-label", "Select a product variant");

  setTimeout(function(){

     $("div.hero__link a[href^='https://www.alrossa.com/search']").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });

   
        
 $("div.hero__link a[href^='https://alrossa.com/collections/vendors?q=Saya']").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });
 $("div.hero__link a[href^='https://alrossa.com/collections/sunkissed']").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });

    $("div.hero__link a[href='https://www.alrossa.com/collections/patricks']").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });
$("textarea#h-captcha-response-0h6lmhh525r").attr("aria-label","Enter Captcha");
   },1000)

let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;


   $("textarea[name='h-captcha-response']").attr("aria-label","Enter Captcha");
    if ( $('#goog-gt-votingInputSrcLang').length) {

$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
 $("img.add-to-cart__success").attr("alt","add to cart success");     
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 20) {
        clearInterval(Intervaltime_google);
       
    }
}

});
